/* eslint-disable @typescript-eslint/no-dynamic-delete */
import qs from 'qs'
import {type Location} from 'history'

let navigateRef: ((location: Partial<Location>) => unknown) | null = null

export const initQueryParamNavigator = (navigateFn: typeof navigateRef) => {
    navigateRef = navigateFn
}

const updateSearchParams = (
    updater: (current: Record<string, unknown>) => Record<string, unknown>,
) => {
    if (!navigateRef) {
        throw new Error('navigateRef not set. Call initQueryParamNavigator first.')
    }

    const currentParams = qs.parse(window.location.search, {ignoreQueryPrefix: true})
    const nextParams = updater(currentParams)

    navigateRef({
        search: qs.stringify(nextParams, {addQueryPrefix: true}),
    })
}

export const addQueryParam = (param: string, value: string): void => {
    updateSearchParams((curr) => ({...curr, [param]: value}))
}

export const addMultipleQueryParam = (
    param1: string,
    value1: string,
    param2: string,
    value2: string,
): void => {
    updateSearchParams((curr) => ({...curr, [param1]: value1, [param2]: value2}))
}

export const hasQueryParam = (param: string, value: string): boolean => {
    const queryParams = qs.parse(window.location.search, {ignoreQueryPrefix: true})
    return queryParams[param] === value
}

export const removeQueryParam = (param: string): void => {
    updateSearchParams((curr) => {
        delete curr[param]
        return curr
    })
}

export const removeMultipleQueryParam = (params: string[]): void => {
    updateSearchParams((curr) => {
        params.forEach((p) => delete curr[p])
        return curr
    })
}

export const replaceDateParams = (fromDate: string | null, toDate: string | null): void => {
    updateSearchParams((curr) => {
        delete curr.fromDate
        delete curr.toDate

        if (fromDate) {
            curr.fromDate = fromDate
        }
        if (toDate) {
            curr.toDate = toDate
        }

        return curr
    })
}

export const getQueryParams = (): Record<string, string> => {
    return qs.parse(window.location.search, {ignoreQueryPrefix: true}) as Record<string, string>
}
